<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Daily Signup Report</h5>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="4">
                <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00)</label>
                <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime" :state="$v.sStartTime.$error?false:null" @blur.native="$v.sStartTime.$touch"></b-input>
                <div v-if="$v.sStartTime.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.sStartTime.required">Start Time is required</div>
                  <div class="invalid-feedback d-block" v-if="!$v.sStartTime.rangeInvalid">Date Range should be equal to or below 3 months</div>
                </div>
              </b-col>
              <b-col sm="4">
                <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59)</label>
                <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime" :state="$v.sEndTime.$error?false:null" @blur.native="$v.sEndTime.$touch"></b-input>
                <div v-if="$v.sEndTime.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.sEndTime.required">Start Time is required</div>
                  <div class="invalid-feedback d-block" v-if="!$v.sEndTime.rangeInvalid">Date Range should be equal to or below 3 months</div>
                </div>
              </b-col>
              <b-col sm="4" class="align-self-end">
                <b-button id="sBtn" variant="primary" @click="searchDailySignup" :disabled="$v.sStartTime.$invalid || $v.sEndTime.$invalid"><i class="fa fa-search"></i> Search</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-image'></i> Daily Sign Report Data </h3>
          </b-card-header>
          <template v-if="!fetchingData">
            <b-card-body>
              <b-badge variant="danger">Level 1</b-badge> Same mobile or browser device
              <b-badge variant="warning" class="ml-3">Level 2</b-badge> Same IP address for last login
            </b-card-body>
            <b-card-body>
              <div class="overflow-auto">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
                  <template v-slot:cell(Level)="data">
                    <template v-if="data.item.Count > 0">
                      <b-button variant="primary" class="btn-sm" @click="getTransactionDetail(data.item)"><i class="fa fa-eye"></i></b-button>
                    </template>
                  </template>
                  <template v-slot:cell(Deposit)="data">
                    {{ format(data.item.Deposit, '0,0.00') }}
                  </template>
                  <template v-slot:cell(Withdraw)="data">
                    {{ format(data.item.Withdraw, '0,0.00') }}
                  </template>
                  <template v-slot:cell(Promotion)="data">
                    {{ format(data.item.Promotion, '0,0.00') }}
                  </template>
                  <template v-slot:cell(Turnover)="data">
                    {{ format(data.item.Turnover, '0,0.00') }}
                  </template>
                  <template v-slot:cell(Netwin)="data">
                    {{ format(data.item.Netwin, '0,0.00') }}
                  </template>
                  <template v-slot:cell(Status)="data">
                    <b-badge variant="success" v-if="data.item.Status === 0">Active</b-badge>
                    <b-badge variant="danger" v-else-if="data.item.Status === 1">Disable</b-badge>
                    <b-badge variant="warning" v-else-if="data.item.Status === 2">Frozen</b-badge>
                  </template>
                  <template v-slot:cell(Level)="data">
                    <template v-if="data.item.Count > 0">
                      <b-button variant="primary" class="btn-sm" @click="getTransactionDetail(data.item)"><i class="fa fa-eye"></i></b-button>
                    </template>
                  </template>
                  <template v-slot:cell(DuplicateAccount)="data">
                    {{ data.item.Count }}
                  </template>
                  <template v-slot:row-details="data">
                    <ReportDetail :records="data.item.details" reportType="signup" />
                  </template>
                </b-table>
              </div>
              <nav>
                <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </b-card-body>
          </template>
          <template v-else>
            <b-card-body>
              Fetching Data
            </b-card-body>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ReportDetail from './ReportDetail'
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import moment from 'moment-timezone'
  import numeral from 'numeral'
  const {required} = require('vuelidate/lib/validators')

  export default {
    name: 'daily-signup-table',
    components: {
      ReportDetail
    },
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        fetchingData: true,
        sStartTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD'),
        sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD'),
        currentPage: 1,
        perPage: 50,
        items: [],
        fields: [
          {key: 'Level', label: 'Operate'},
          {key: 'Username', label: 'Username'},
          {key: 'MemberId', label: 'MemberId'},
          {key: 'MachineNo', label: 'MachineNo'},
          {key: 'Count', label: 'Duplicate Account'},
          {key: 'AddIP', label: 'IP'},
          {key: 'BankBranch', label: 'BankBranch'},
          {key: 'Deposit', label: 'Deposit'},
          {key: 'Withdraw', label: 'Withdraw'},
          {key: 'Netwin', label: 'Netwin'},
          {key: 'Promotion', label: 'Promotion'},
          {key: 'Turnover', label: 'Turnover'},
          {key: 'Status', label: 'Status'},
          {key: 'LastModifyDate', label: 'Detected Date'}
        ]
      }
    },
    validations: {
      sStartTime: {
        required,
        rangeInvalid: function () {
          return this.validateDateRange()
        }
      },
      sEndTime: {
        required,
        rangeInvalid: function () {
          return this.validateDateRange()
        }
      }
    },
    methods: {
      async getTransactionDetail (item) {
        if (item._showDetails) {
          item._showDetails = false
        } else {
          try {
            let url = `/report/member/risk/getDailySignupById`
            const userModifyDate = moment(item.LastModifyDate).format('YYYY-MM-DD')
            const payload = {
              startDate: userModifyDate,
              endDate: userModifyDate,
              memberId: item.MemberId
            }
            Events.$emit('loader')
            const { data } = await this.$http.post(this.API_ENDPOINT + url, payload, { headers: { 'Content-Type': 'application/json' } })
            item.details = data.records
            this.$set(item, '_showDetails', true)
          } catch (err) {
            let e = err.response.data
            let code = e.code
            let msg = e.msg
            Events.$emit('alert', 'error', code, msg)
          } finally {
            Events.$emit('loader')
          }
        }
      },
      format (val, format) {
        return numeral(val).format(format)
      },
      getRowCount (items) {
        return items.length
      },
      validateDateRange () {
        let from = moment(this.sStartTime)
        let to = moment(this.sEndTime)
        let duration = moment.duration(to.diff(from))
        let monthsRange = duration.asMonths()
        return !(Math.abs(monthsRange) > 3)
      },
      async searchDailySignup () {
        try {
          this.fetchingData = true
          let url = `/report/member/risk/getDailySignup`
          const payload = {
            startDate: this.sStartTime,
            endDate: this.sEndTime
          }
          const { data } = await this.$http.post(this.API_ENDPOINT + url, payload, { headers: { 'Content-Type': 'application/json' } })
          this.items = data.records
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          this.fetchingData = false
        }
      }
    },
    created () {
      this.searchDailySignup()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/risk/DailySignupAnalysisTable.vue